@if (!processing) {
  <div ngbDropdown class="d-inline-block text-nowrap">
    <button id="actionDropdown" class="btn btn-secondary" ngbDropdownToggle>Select Action</button>
    <div ngbDropdownMenu aria-labelledby="actionDropdown">
      @if (canUnlock) {
        <a
          class="dropdown-item"
          href="#unlock"
          (click)="onUnlockClick($event)"
          >Unlock</a
          >
        }
        @if (canDeactivate) {
          <a
            class="dropdown-item"
            href="#deactivate"
            (click)="onDeactivateClick($event)"
            >Deactivate</a
            >
          }
          @if (canReactivate) {
            <a
              class="dropdown-item"
              href="#reactivate"
              (click)="onReactivateClick($event)"
              >Reactivate</a
              >
            }
            @if (canResetPassword) {
              <a
                class="dropdown-item"
                href="#resetPassword"
                (click)="onResetPasswordClick($event)"
                >Reset Password</a
                >
              }
              @if (canResendInvitation) {
                <a
                  class="dropdown-item"
                  href="#resendInvitation"
                  (click)="onResendInvitationClick($event)"
                  >Resend Invitation</a
                  >
                }
                @if (canEdit) {
                  <a
                    class="dropdown-item"
                    routerLink="/capture-admin/users/{{user.id}}/edit"
                    >Edit User</a
                    >
                  }
                  @if (canViewChangeLog) {
                    <a
                      class="dropdown-item"
                      routerLink="/capture-admin/users/{{ user.id }}/change-log"
                      >View Change Log</a
                      >
                    }
                  </div>
                </div>
              } @else {
                <fa-icon [icon]="['fas', 'circle-notch']" size="sm" [animation]="'spin'" /> Processing...
              }
